document.addEventListener('DOMContentLoaded', function () {
  let miniCartButton = document.querySelector('[aria-controls="mini-cart"]') 
  if (miniCartButton) {
    miniCartButton.addEventListener('click', ()=>{
      if (typeof BSS_B2B == 'object' ) {
        setTimeout(()=>{
          BSS_B2B.observer.cartSubject.listenCartCheckout()
        },500)
      }
    })
  }
});


if (window.location.pathname === '/cart') {
    let button;
    let styleTag;
    setTimeout(() => {
        function handleButtonClick(e) {
            e.preventDefault();
            button = document.querySelector(".cart__checkout-button");
            if (button) {
                styleTag = document.createElement('style');
                styleTag.id = 'checkoutButtonStyles';
                styleTag.textContent = `
                    .cart__checkout-button {
                        pointer-events: none !important;
                        opacity: 0.6 !important;
                    }
                `;
                document.head.appendChild(styleTag);

                setTimeout(() => {
                    document.head.removeChild(styleTag);
                }, 6000);
            }
        }
        document.querySelector('.cart__checkout-button').addEventListener('click', function (event) {
            handleButtonClick(event);
        }, true);
    }, 500);
}else {
  setTimeout(() => {
        function handleButtonClick(e) {
            e.preventDefault();
            button = document.querySelector(".mini-cart__drawer-footer .checkout-button");
            if (button) {
                styleTag = document.createElement('style');
                styleTag.id = 'checkoutButtonStyles';
                styleTag.textContent = `
                    .mini-cart__drawer-footer .checkout-button {
                        pointer-events: none !important;
                        opacity: 0.6 !important;
                    }
                `;
                document.head.appendChild(styleTag);

                setTimeout(() => {
                    document.head.removeChild(styleTag);
                }, 6000);
            }
        }
        document.querySelector('.mini-cart__drawer-footer .checkout-button').addEventListener('click', function (event) {
            handleButtonClick(event);
        }, true);
        console.log(document.querySelector('.mini-cart__drawer-footer .checkout-button'))
        let quickAddDrawer = document.querySelector('.mini-cart.drawer')
                                    if (quickAddDrawer) {   
                                        let observer = new MutationObserver(function(mutations) {
                                            mutations.forEach(function(m) {
                                            
                                                document.querySelector('.mini-cart__drawer-footer .checkout-button').addEventListener('click', function (event) {
            handleButtonClick(event);
        }, true);
                                            });
                                        });
                                        observer.observe(quickAddDrawer, {childList: true});
                                    }
    }, 2500);
}